export default __webpack_public_path__ + "static/media/Nearshoring_.8f2b2191.webp";